import { useSelector } from "react-redux";
import { selectUserInfo } from "../store/auth";

export const useUserInfo = () => {
  return useSelector((state) => selectUserInfo(state));
};
